<ng-container *transloco="let t">
  <div class="flex flex-col gap-2">
    <!-- Label -->
    @if (props.label) {
      <label [for]="id" class="font-semibold">
        {{ props.label }}
      </label>
    }

    <!-- Text Display -->
    <div class="relative">
      <div
        class="p-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded min-h-[2.5rem] max-h-48 overflow-y-auto text-sm text-gray-700 dark:text-gray-300"
        [style.word-break]="'break-word'"
      >
        {{ displayValue }}
      </div>
    </div>
  </div>
</ng-container>
